export type DemoDockSkuId = 'free' | 'baseline' | 'premium';

export type DemoDockSku = {
  id: DemoDockSkuId;
  name: string;
  priceLabel: string;
  monthlyCredits: number;
  description: string;
};

export type DemoDockCreditAccount = {
  skuId: DemoDockSkuId;
  creditsUsed: number;
  reservedCredits: number;
  cycleStartedAt: string;
};

export type DemoDockCreditSummary = {
  account: DemoDockCreditAccount;
  sku: DemoDockSku;
  usedCredits: number;
  reservedCredits: number;
  remainingCredits: number;
  totalCredits: number;
  hasCredits: boolean;
};

export const demoDockSkus: DemoDockSku[] = [
    {
      id: 'free',
      name: 'Free',
      priceLabel: 'Free',
      monthlyCredits: 30,
      description: 'Low-credit sandbox access for trying Demo Dock.',
    },
    {
      id: 'baseline',
      name: 'Baseline',
      priceLabel: '10.99 / month',
      monthlyCredits: 100,
      description: 'A practical monthly allowance for regular demos.',
    },
    {
      id: 'premium',
      name: 'Premium',
      priceLabel: '18.99 / month',
      monthlyCredits: 300,
      description: 'Higher volume access for heavier demo workloads.',
    },
  ];